import React from 'react';

const DanceInPinkPage = () => {
    return (    
      <div class="context">
          <div class="area" >
            <h3 style={{float:'left', paddingTop: 60, paddingLeft:15}}>DANCING</h3>
                <h1 style={{textAlign: 'center',fontSize: 90, paddingTop: 30,}}>Dance Dance Dance</h1><br /><br />
                <h5 style={{color: "LimeGreen", fontSize: 30, paddingTop: 5}}>“Any kind of dancing is better than no dancing at all.”</h5>

              <ul class="circles">
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
              </ul>
            <div
              className="video pink"
              style={{
                    position: "relative",
                    left: 440,
                  }}
              >
                <iframe width="941" height="529" src="https://www.youtube.com/embed/-BkcictxDCA?autoplay=1" frameborder="0" allow="accelerometer; allow=autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>   
                <p><b>Dance first. Think later. 🏵️</b></p>
          </div >
      </div>
    );
}

export default DanceInPinkPage;
